/* =========================================================================
   "COMBINA COM": adicionar em UM CLIQUE.

   Vale para o item de variante única (hoje o Protetor de Lavagem). Abrir o
   pop-up de compra rápida para um produto sem cor nem tamanho seria pedir que a
   cliente confirme uma escolha que não existe.

   Delegação no document, não listener no botão: a gaveta é redesenhada inteira a
   cada mudança do carrinho, e o botão de agora não é o mesmo de daqui a pouco.

   Trava por variante enquanto a requisição corre: sem isso dois toques rápidos —
   comuns quando nada muda na tela no primeiro — colocariam duas unidades.
   ========================================================================= */

(function () {
  if (window.__tpBumpAdd) return;
  window.__tpBumpAdd = true;

  var ocupado = {};

  function gaveta() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-tp-bump-add]');
    if (!btn) return;
    ev.preventDefault();

    var id = btn.getAttribute('data-tp-bump-add');
    if (!id || ocupado[id]) return;
    ocupado[id] = true;

    var rotulo = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adicionando...';

    var c = gaveta();
    var corpo = { items: [{ id: id, quantity: 1 }] };
    if (c && typeof c.getSectionsToRender === 'function') {
      corpo.sections = c.getSectionsToRender().map(function (s) { return s.id; });
      corpo.sections_url = window.location.pathname;
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || 'falha ao adicionar');
        /* O redesenho troca a gaveta inteira, e o card do "combina com" some
           junto — ele só existe enquanto o produto não está no carrinho. Por isso
           não há estado a restaurar depois daqui. */
        if (c && typeof c.renderContents === 'function') {
          if (c.classList.contains('is-empty')) c.classList.remove('is-empty');
          c.renderContents(res);
        }
      })
      .catch(function (err) {
        console.error('[tp-bump-add]', err);
        // O botão continua na tela: devolver o rótulo evita deixá-lo travado.
        btn.disabled = false;
        btn.textContent = rotulo;
      })
      .finally(function () { ocupado[id] = false; });
  });
})();
